module.exports = __webpack_public_path__ + "img/login_background.10b08abb.jpg";